import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/api";
import { TopBar, BottomNav, InstallBanner } from "./components/Shell";
import Home from "./pages/Home";
import Discover from "./pages/Discover";
import ComicPage from "./pages/ComicPage";
import Reader from "./pages/Reader";
import Create from "./pages/Create";
import Leaderboards from "./pages/Leaderboards";
import Profile from "./pages/Profile";
import { Library, Notifications, Creators, Policy, PaymentResult } from "./pages/Misc";
import Earnings from "./pages/Earnings";
import Subscriptions from "./pages/Subscriptions";
import Admin from "./pages/Admin";
import { Login, Register, Forgot, Reset } from "./pages/Auth";
import Settings from "./pages/Settings";

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-center jx-muted">Loading…</div>;
  if (!user) return <Navigate to="/login" />;
  if (admin && user.role !== "admin") return <Navigate to="/" />;
  return children;
};

function Me() {
  const { user } = useAuth();
  return <Navigate to={`/u/${user.username}`} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="grain min-h-screen">
          <TopBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/discover" element={<Discover />} />
            <Route path="/marketplace" element={<Discover market />} />
            <Route path="/comic/:id" element={<ComicPage />} />
            <Route path="/read/:id" element={<Reader />} />
            <Route path="/create" element={<Protected><Create /></Protected>} />
            <Route path="/leaderboards" element={<Leaderboards />} />
            <Route path="/profile" element={<Protected><Me /></Protected>} />
            <Route path="/u/:username" element={<Profile />} />
            <Route path="/creators" element={<Creators />} />
            <Route path="/library" element={<Protected><Library /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="/earnings" element={<Protected><Earnings /></Protected>} />
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/payment/:result" element={<PaymentResult />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<Forgot />} />
            <Route path="/reset-password" element={<Reset />} />
          </Routes>
          <BottomNav />
          <InstallBanner />
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
